<template>
  <path
    d="M20 2.00018H4C2.89 2.00018 2 2.89018 2 4.00018V15.0002C2 16.1102 2.89 17.0002 4 17.0002H8V22.0002L12 20.0002L16 22.0002V17.0002H20C21.11 17.0002 22 16.1102 22 15.0002V4.00018C22 2.89018 21.11 2.00018 20 2.00018ZM20 15.0002H4V13.0002H20V15.0002ZM20 10.0002H4V5.00018C4 4.45018 4.45 4.00018 5 4.00018H19C19.55 4.00018 20 4.45018 20 5.00018V10.0002Z"
  />
</template>
